import { Box, css, Stack, styled } from '@mui/material';
import type { ReactNode } from 'react';

const StyledRoot = styled(Box)(
  ({ theme }) => css`
    width: ${theme.spacing(90)};
  `,
);

interface PageWrapperProps {
  children: ReactNode;
}

export function PageWrapper({ children }: PageWrapperProps) {
  return (
    <StyledRoot>
      <Stack sx={{ py: 2 }}>{children}</Stack>
    </StyledRoot>
  );
}
